import React from 'react'
import injectStyles from 'react-jss'
import ControlWrapper from './../ControlWrapper'

const styles = {
  container: {
    fontSize: 13,
  },
}

const UnknownControl = ({ type, classes, ...otherProps }) => {
  return <ControlWrapper {...otherProps}>
    <div className={classes.container}>
      Unknown Component (type '{type}')
    </div>
  </ControlWrapper>
}

export default injectStyles(styles)(UnknownControl)



// WEBPACK FOOTER //
// ./src/modules/UnknownControl/UnknownControl.js